<div [formGroup]="form()" class="input-wrapper">
  @if (inputParam().dataType === 'bool') {
    <mat-slide-toggle class="checkbox" [formControlName]="input().name"
      >{{ input().displayName }}
    </mat-slide-toggle>
  } @else {
    @if (isListParam()) {
      <div class="mat-form-field-input">
        <div class="row header">
          <div class="row">
            <div
              (click)="collapseList.set(!collapseList())"
              (keydown.enter)="collapseList.set(!collapseList())"
              tabindex="0"
              class="chevro-icon">
              <mat-icon>{{ collapseList() ? 'chevron_right' : 'expand_more' }}</mat-icon>
            </div>
            <h3 class="label display-name">{{ input().displayName }}:</h3>
          </div>
          <i>
            @if (input().isList) {
              <div class="row">
                [
                @for (value of form().value[input().name]; track $index; let last = $last) {
                  <div>
                    {{ value }}
                    @if (!last) {
                      <span>,&nbsp;</span>
                    }
                  </div>
                }
                ]
              </div>
            }
            @if (!input().isList) {
              <div class="row">
                {{ form().value[input().name] }}
              </div>
            }
          </i>
        </div>
        @if (!collapseList()) {
          <div class="expanded-content">
            <div class="list-top-row">
              @if (input().isList) {
                <mat-checkbox
                  color="primary"
                  (change)="list.toggleAll()"
                  [checked]="list.allSelected()"
                  [indeterminate]="list.hasSelection() && !list.allSelected()">
                  <i>Toggle all</i>
                </mat-checkbox>
              }
              <button
                type="button"
                mat-icon-button
                size="8pt"
                (click)="resetOptions()"
                (keydown.enter)="resetOptions()"
                matTooltip="Restore default values."
                tabindex="0">
                <mat-icon>restore</mat-icon>
              </button>
            </div>
            @if (input().isList) {
              <mat-divider></mat-divider>
            }
            <div class="list-container">
              @for (option of list.options(); track $index; let i = $index) {
                <div class="list-item-wrapper">
                  <mat-checkbox
                    color="primary"
                    (change)="list.toggle(option)"
                    [checked]="list.isSelected(option)">
                  </mat-checkbox>
                  <div class="label">
                    @if (editSelection() === option) {
                      <mat-form-field subscriptSizing="dynamic">
                        <input
                          (input)="handleInputChange($event, 'edit')"
                          (keydown.enter)="$event.stopPropagation(); changeOptionValue(i)"
                          [type]="inputParam().dataType"
                          [value]="option.value"
                          matInput />
                      </mat-form-field>
                      <div class="edit-buttons">
                        <button
                          type="button"
                          color="primary"
                          (click)="changeOptionValue(i)"
                          mat-flat-button
                          matTooltip="Confirm Changes">
                          OK
                        </button>
                        <button
                          type="button"
                          color="primary"
                          (click)="
                            option.value = option.initValue;
                            editSelection.set(list.options()[i]);
                            $event.stopPropagation()
                          "
                          mat-flat-button
                          matTooltip="Click to reset to initial Value.">
                          Reset
                        </button>
                      </div>
                    } @else {
                      <div
                        (click)="list.toggle(option)"
                        (keydown.enter)="list.toggle(option)"
                        tabindex="0"
                        class="text">
                        {{ option.value }}
                      </div>
                    }
                  </div>
                  @if (input().isModifiable && input().modifications?.allowEdit) {
                    @if (input().isModifiable && editSelection() !== option) {
                      <mat-icon
                        color="primary"
                        (click)="$event.preventDefault(); editSelection.set(option)"
                        (keydown.enter)="$event.preventDefault(); editSelection.set(option)"
                        class="edit-icon"
                        matTooltip="Click to edit entry">
                        edit
                      </mat-icon>
                    }
                  }
                  @if (input().isModifiable && input().modifications?.allowDelete) {
                    <mat-icon
                      color="primary"
                      (click)="removeOption($event, option)"
                      (keydown.enter)="removeOption($event, option)"
                      class="edit-icon"
                      matTooltip="Click to remove entry">
                      delete
                    </mat-icon>
                  }
                </div>
              }
            </div>
            @if (input().isModifiable) {
              <mat-divider></mat-divider>
            }
            @if (input().isModifiable && input().modifications?.allowNew) {
              <div class="list-add-item">
                <mat-form-field class="input-field" subscriptSizing="dynamic">
                  <input
                    #addField
                    (input)="handleInputChange($event, 'add')"
                    (keydown.enter)="$event.preventDefault(); handleAddNewItem()"
                    matInput
                    placeholder="Add new item" />
                </mat-form-field>
                <div>
                  <button
                    type="button"
                    (click)="handleAddNewItem()"
                    class="add-button"
                    color="primary"
                    mat-flat-button
                    matTooltip="Add item"
                    [disabled]="addValue() === ''">
                    Add
                  </button>
                </div>
              </div>
            }
          </div>
        }
      </div>
    } @else {
      <mat-form-field class="mat-form-field-input" subscriptSizing="dynamic">
        <mat-label class="display-name" [attr.for]="input().name"
          >{{ input().displayName }}
        </mat-label>
        @if (inputParam().options?.length && !input().isModifiable) {
          <mat-select
            [formControlName]="input().name"
            [multiple]="input().isList"
            [id]="input().name">
            @for (possValue of inputParam().options; track possValue) {
              <mat-option [value]="possValue">
                {{ possValue }}
              </mat-option>
            }
          </mat-select>
        } @else {
          <input
            [formControlName]="input().name"
            [id]="input().name"
            [matAutocomplete]="auto"
            [placeholder]="inputParam().placeholder"
            matInput />
          <mat-autocomplete #auto="matAutocomplete">
            @for (option of filteredOptions(); track option) {
              <mat-option [value]="option">
                {{ option }}
              </mat-option>
            }
          </mat-autocomplete>
        }
      </mat-form-field>
    }
  }
  <div [ngClass]="{ 'top-align': !collapseList() }" class="help-icon">
    <mat-icon [matTooltip]="input().description" color="primary">help</mat-icon>
  </div>
</div>
